<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
    >
      <v-btn icon @click="goBack()">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title>Edit {{ userId }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout row wrap>
        <v-flex
          xs12
          text-xs-center
          layout
          align-content-start
          justify-center
          pa-3
        >
          <v-form ref="form" v-model="frmValid">
            <v-text-field
              v-model="txtEmail"
              :rules="[v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'Invalid email format']"
              :counter="150"
              label="E-mail"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtPassword"
              v-if="!userId"
              label="Password"
              :type="'password'"
              required
            ></v-text-field>
            <v-select
              v-model="cboTitle"
              :items="titles"
              :rules="[v => !!v || 'Please select title']"
              label="Title"
              required
            ></v-select>
            <v-text-field
              v-model="txtFirstName"
              :rules="[v => !!v || 'First name is required']"
              :counter="50"
              label="First Name"
              required
            ></v-text-field>
            <v-text-field
              v-model="txtLastName"
              :counter="50"
              label="Last Name"
            ></v-text-field>
            <v-text-field
              v-model="txtPhone"
              :rules="[v => !!v || 'Phone is required']"
              :counter="50"
              label="handphone"
              required
            ></v-text-field>
            <v-select
              v-model="cboTimezone"
              :items="timezones"
              label="Timezone"
            ></v-select>

            <v-btn
              :disabled="!frmValid"
              @click="submit"
            >
              Save
            </v-btn>
            <v-btn v-if="userId" @click.stop="dialogResetPassword = true">
              Reset Password
            </v-btn>
          </v-form>
          <v-dialog v-model="dialogResetPassword" max-width="300px">
            <v-card>
              <v-card-title>
                <strong>Reset Password</strong>
              </v-card-title>
              <v-card-text>
                <v-form ref="formResetPassword" v-model="frmResetPasswordValid" @submit.prevent="">
                  <v-text-field
                    label="Password"
                    v-model="txtNewPassword"
                    :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
                    :type="'password'"
                    required
                  ></v-text-field>
                  <v-text-field
                    label="Confirm Password"
                    v-model="txtNewPassword2"
                    :rules="[v => !!v || 'Password is required', v => (v && v.length >= 8) || 'Password must be 8 characters or more']"
                    :type="'password'"
                    required
                  ></v-text-field>
                  <v-btn
                    :disabled="!frmResetPasswordValid"
                    @click="submitResetPassword()"
                  >
                    Reset
                  </v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>
  </div>
</template>

<style scoped>
form {
  width: 100%;
}
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import Loading from '@/components/Loading.vue'
import router from '../router'
import axios from 'axios'

export default {
  props: [
    'userId'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data: () => ({
    drawer: false,
    loading: false,
    frmValid: true,
    txtEmail: '',
    txtPassword: '',
    cboTitle: '',
    txtFirstName: '',
    txtLastName: '',
    txtPhone: '',
    cboTimezone: '',
    dialogResetPassword: false,
    frmResetPasswordValid: false,
    txtNewPassword: '',
    txtNewPassword2: ''
  }),

  mounted () {
    this.openDrawerForDesktop()
    this.getCustomer(this.userId)
  },

  methods: {
    getCustomer: function (userId) {
      if (userId) {
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/user/' + userId)
          .then(resp => {
            this.loading = false
            console.log(resp.data)
            if (resp.data.status === 'success') {
              this.txtEmail = resp.data.data.loginEmail
              this.cboTitle = resp.data.data.title
              this.txtFirstName = resp.data.data.firstName
              this.txtLastName = resp.data.data.lastName
              this.txtPhone = resp.data.data.phone
              this.cboTimezone = resp.data.data.gmtTimezone
            } else {
              console.log('unable to load customer details: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              } else if (error.response.status === 403) {
                this.showAlert(error)
              }
              this.loading = false
            }
          })
      }
    },
    submit () {
      if (this.$refs.form.validate()) {
        if (this.userId) {
          this.loading = true
          axios.put(process.env.VUE_APP_API_ROOT + '/v1/user/' + this.userId, {
            loginEmail: this.txtEmail,
            title: this.cboTitle,
            firstName: this.txtFirstName,
            lastName: this.txtLastName,
            phone: this.txtPhone,
            gmtTimezone: (this.cboTimezone.length > 0 ? this.cboTimezone : null)
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/sellers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        } else {
          this.loading = true
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/user', {
            loginEmail: this.txtEmail,
            password: this.txtPassword,
            title: this.cboTitle,
            firstName: this.txtFirstName,
            lastName: this.txtLastName,
            phone: this.txtPhone,
            gmtTimezone: (this.cboTimezone.length > 0 ? this.cboTimezone : null)
          }, {
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(resp => {
              this.loading = false
              console.log(resp.data)
              if (resp.data.status === 'success') {
                router.push('/sellers')
              } else {
                window.alert(resp.data.message)
              }
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + this.$route.fullPath)
                } else if (error.response.status === 403) {
                  this.showAlert(error)
                }
                this.loading = false
              }
            })
        }
      }
    },
    submitResetPassword () {
      if (this.$refs.formResetPassword.validate()) {
        if (this.userId) {
          if (this.txtNewPassword === this.txtNewPassword2) {
            this.loading = true
            axios.put(process.env.VUE_APP_API_ROOT + '/v1/user/' + this.userId, {
              password: this.txtNewPassword
            }, {
              headers: {
                'Content-Type': 'application/json'
              }
            })
              .then(resp => {
                this.loading = false
                console.log(resp.data)
                if (resp.data.status === 'success') {
                  window.alert('Password has been reset')
                  this.dialogResetPassword = false
                } else {
                  window.alert(resp.data.message)
                }
              })
              .catch(function (error) {
                if (error.response) {
                  console.log(error.response.status)
                  if (error.response.status === 401) {
                    router.push('/login?next=' + this.$route.fullPath)
                  } else if (error.response.status === 403) {
                    this.showAlert(error)
                  }
                  this.loading = false
                }
              })
          } else {
            window.alert('Password mismatch')
          }
        }
      }
    }
  }
}
</script>
